import { render, staticRenderFns } from "./ProjectManagementArchiveCardModal.vue?vue&type=template&id=ed049c66&"
import script from "./ProjectManagementArchiveCardModal.vue?vue&type=script&lang=js&"
export * from "./ProjectManagementArchiveCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports